import TermOfUse from './term-of-use';

export default TermOfUse;
